<template>
    <v-col :cols="cols" class="ma-0 pa-0">
        <div class="form-group">
            <label v-if="items.outerLabel"
                ><span class="outlabel">{{ items.outerLabel }}</span></label
            >
            <v-select
                v-if="!type"
                v-model="items.selected"
                :items="items.answers"
                item-text="label"
                item-value="value"
                :label="items.label"
                :disabled="items.disabled"
                :placeholder="items.placeholder"
                atta
                outlined
                dense
                :rules="items.rules"
                :value="items.selected"
                @change="change"
                :menu-props="{ offsetY: true }"
                :loading="loading"
                ><template #item="{ item }">
                    <span class="labelStyle"> {{ item.label }}</span>
                </template></v-select
            >
        </div>
    </v-col>
</template>
<script>
export default {
    name: 'drop',
    props: ['fields', 'type', 'color', 'loading', 'order', 'cols'],
    data() {
        return {
            field: this.items
        }
    },
    methods: {
        change() {
            this.$emit('change', true)
        }
    },
    computed: {
        items() {
            return this.fields
        }
    },
    created() {
        this.$emit('fields', this.field)
    },
    mounted() {
        this.$emit('fields', this.field)
    },
    updated() {
        this.field = this.fields
    }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,400;1,300&display=swap');

.labelStyle {
    font-family: Inter !important;
    font-size: 14px !important;
    font-weight: 400;
}
.outlabel {
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
}
</style>
